import { useCallback, useState } from "react";

export function LabeledInput({
  label,
  value,
  onChange,
}: {
  label: string;
  value: string;
  onChange: (val: string) => void;
}) {
  const [localValue, setLocalValue] = useState(value);
  const [prevValue, setPrevValue] = useState(value);

  if (value !== prevValue) {
    setPrevValue(value);
    setLocalValue(value);
  }

  const handleBlur = useCallback(() => {
    if (localValue !== value) {
      onChange(localValue);
    }
  }, [localValue, value, onChange]);

  return (
    <div className="flex flex-col gap-0.5">
      <span className="text-xxxs font-mono uppercase tracking-tight text-gray-500">{label}</span>
      <input
        type="text"
        value={localValue}
        onChange={(e) => setLocalValue(e.target.value)}
        onBlur={handleBlur}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            onChange(localValue);
          }
        }}
        className="w-full px-1.5 py-1 text-xxs font-mono bg-transparent border border-gray-200 dark:border-gray-700 rounded-4 outline-none focus:border-gray-400 dark:focus:border-gray-500"
      />
    </div>
  );
}
